import comp from "./DraggableRow";
export default comp;
